function handleDismiss(cmp) {
    const e = cmp.dismiss.emit();
    if (!e.defaultPrevented) {
        cmp.elm.remove();
    }
}

export { handleDismiss as h };
